import React, { useContext, useEffect, useState } from "react";
import { NavDropdown } from "react-bootstrap";
import light_archive_outline from "../../../assets/archiveColor.png";
import { IoBag, IoNotifications, IoSearch } from "react-icons/io5";
import { errorPopup, successPopup } from "../../../Utils/ToasterMessage";
import profileLight from "../../../assets/iconamoon_profile-light.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import formkit_help from "../../../assets/formkit_help.png";
import kaamwalaLogo from "../../../assets/KAAMVALALogo.png";
import { CiSettings } from "react-icons/ci";
import UserContext from "../ContextApi/UserContext";
import { IoLogOutOutline } from "react-icons/io5";
import Dropdown from "react-bootstrap/Dropdown";
import { URLS } from "../../../Utils/App_urls";
import Navbar from "react-bootstrap/Navbar";
import { FaBookmark, FaUserAlt } from "react-icons/fa";
import Nav from "react-bootstrap/Nav";
import axios from "axios";
import "./Navbar.css";
import {
  getAllNotificationUser,
  markAllAsReadUser,
  markReadAndRefreshNotificationsUser,
} from "../ContextApi/UserNotificationContext";
import { Oval } from "react-loader-spinner";

export default function NavBar() {
  const {
    profileImageUrl,
    setProfileImageUrl,
    userProfileComaplete,
    getUserDetails,
    setAllAfterFilter,
  } = useContext(UserContext);
  const [userDetails, setUserDetails] = useState({});
  const [showDropdown, setShowDropdown] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [expandedNav, setExpandedNav] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showBadge, setShowBadge] = useState(false);
  const [allNotication, setAllNotification] = useState([]);
  const [notificationLoader, setNotificationLoader] = useState(false);
  const [showSideNav, setShowSideNav] = useState(false);
  const [jobTitle, setJobTitle] = useState("");
  const showSearchContainer = location.pathname === "/user/find-job";
  const [isJobsOpen, setIsJobsOpen] = useState(false);

  const authenticate = localStorage?.getItem("userToken");

  const handleToggle = () => {
    setShowDropdown(!showDropdown);
  };

  const handleBadgeToggle = () => {
    setShowBadge((prev) => !prev);
  };
  const handleNotification = () => {
    navigate("notifications");
    setShowBadge((prev) => !prev);
  };

  const handleFilterJobsByTitle = (e) => {
    const { value } = e.target;
    setJobTitle(value);
    if (value.trim()) {
      getAllJobs("title", value);
    } else {
      getAllJobs("reset");
    }
  };

  const getAllJobs = (type = "reset", option = "") => {
    const paramsOpt = {
      page: 1,
      limit: 10,
    };

    if (type === "searchText" && option) {
      paramsOpt["searchText"] = option;
    } else {
      paramsOpt["searchText"] = jobTitle;
    }

    Object.keys(paramsOpt).forEach((key) => {
      if (!paramsOpt[key]) {
        delete paramsOpt[key];
      }
    });

    axios
      .get(`${URLS.getAllJob}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        params: type === "reset" ? { page: 1, limit: 10 } : paramsOpt,
      })
      .then((res) => {
        let jobs = res?.data?.result || [];
        setAllAfterFilter(jobs);
        if (type === "searchText") {
          navigate("/user/find-job", { state: { filteredJobs: jobs } });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (jobTitle.trim()) {
      getAllJobs("title", jobTitle);
    }
  };

  const getUserProfileData = () => {
    if (!authenticate) return;

    axios
      .get(`${URLS.get_userProfile}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      })
      .then((res) => {
        setUserDetails(res?.data?.data);
        setProfileImageUrl(res?.data?.data?.profile);
      })
      .catch((err) => console.error(err));
  };

  const handleLogOut = async () => {
    const accessToken = localStorage.getItem("userToken");
    const refreshToken = localStorage.getItem("refreshToken");

    if (!accessToken) {
      clearLocalStorage();
      navigate("/user/login");
      return;
    }

    setLoader(true);

    try {
      if (accessToken && refreshToken) {
        const response = await axios.post(
          `${URLS.logout}`,
          { refreshToken },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        console.log("Logout response:", response);

        if (response.data?.message) {
          successPopup(response.data.message);
        } else {
          successPopup("Logged out successfully");
        }
      } else {
        successPopup("Logged out successfully");
      }

      clearLocalStorage();
      setLoader(false);
      setTimeout(() => navigate("/user/login"), 300);
    } catch (err) {
      console.error("Logout error:", err);
      errorPopup(err?.response?.data?.message || "Logout failed");
      clearLocalStorage();
      setLoader(false);
      navigate("/user/login");
    }
  };

  const clearLocalStorage = () => {
    localStorage.removeItem("userToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userRole");
    localStorage.removeItem("isprofileUserComplete");
  };

  const checkLocation = () => {
    const locationArr = location.pathname.split("/");
    return locationArr || "";
  };

  useEffect(() => {
    getUserProfileData();
    if (authenticate) {
      getUserDetails();
    }
  }, [authenticate]);

  useEffect(() => {
    const fetchNotifications = async () => {
      if (!authenticate) {
        return;
      }

      const notifications = await getAllNotificationUser(5, 1);
      if (notifications) {
        setAllNotification(notifications);
      }
    };
    const intervalId = setInterval(fetchNotifications, 10000);
    return () => clearInterval(intervalId);
  }, [authenticate]);

  const handleMarkAsRead = async (notificationId) => {
    try {
      const updatedNotifications = await markReadAndRefreshNotificationsUser(
        notificationId,
        5,
        1
      );
      setAllNotification(updatedNotifications);
    } catch (error) {
      console.error("Error updating notifications:", error);
    }
  };

  const handleFormateDate = (dateStr = "") => {
    let date = new Date(dateStr);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    const timeFormated = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return ` ${formattedDate} | ${timeFormated}`;
  };

  return (
    <>
      <div className="main-navbar">
        <Navbar
          collapseOnSelect
          expanded={expandedNav}
          expand="lg"
          className="bg-body-tertiary m-0 w-100"
        >
          <Navbar.Brand as={Link} to={authenticate ? "/user/find-job" : "/"}>
            <img
              className="topnavlogo"
              src={kaamwalaLogo}
              alt="kaamwalaLogo"
              width="100px"
            />
          </Navbar.Brand>

          <Navbar.Collapse id="navbarScroll" className="align-items-center">
            <Nav
              className="my-2 my-lg-0 navUIList align-items-center flex-nowrap"
              navbarScroll
            >
              <div className="d-flex justify-content-between  align-items-center">
                {!authenticate && (
                  <Link to="/" className="nav-link">
                    <div
                      className="nav-link font-nav"
                      style={{
                        color: "black",
                      }}
                    >
                      Home
                    </div>
                  </Link>
                )}

                <NavDropdown
                  title={<span className="nav-dropdown-title">jobs</span>}
                  id="employer-dropdown"
                  className="items-hovers"
                  renderMenuOnMount={true}
                >
                  <div className="dropdown_content">
                    <div className="dropdown_column">
                      <h4>Popular categories</h4>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?job-category=accounts"
                      >
                        {" "}
                        Accounts{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?job-category=back-office"
                      >
                        {" "}
                        Back office
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?job-category=beautician"
                      >
                        {" "}
                        Beautician{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?job-category=hardware-engineering"
                      >
                        {" "}
                        Hardware Engineering{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?job-category=field-sales"
                      >
                        {" "}
                        Field sales{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?job-category=receptionist"
                      >
                        {" "}
                        Receptionist{" "}
                      </NavDropdown.Item>
                    </div>

                    <div className="dropdown_column">
                      <h4>Jobs by location</h4>
                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?location=delhi"
                      >
                        {" "}
                        Jobs in Delhi{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?location=Noida"
                      >
                        {" "}
                        Jobs in Noida{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?location=bangalore"
                      >
                        {" "}
                        Jobs in Bangalore{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?location=hyderabad"
                      >
                        {" "}
                        Jobs in Hyderabad{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?location=chennai"
                      >
                        {" "}
                        Jobs in Surat{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?location=pune"
                      >
                        {" "}
                        Jobs in Pune{" "}
                      </NavDropdown.Item>
                    </div>
                  </div>
                </NavDropdown>

                <NavDropdown
                  title={<span className="nav-dropdown-title">Companies</span>}
                  id="employer-dropdown"
                  className="items-hovers"
                  renderMenuOnMount={true}
                >
                  <div className="dropdown_content">
                    <div className="dropdown_column">
                      <h4>Popular Industries</h4>
                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?industry=media"
                      >
                        {" "}
                        Media & Entertainment{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?industry=it"
                      >
                        {" "}
                        IT Companies{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?industry=retail"
                      >
                        {" "}
                        Retail Sector{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?industry=fintech"
                      >
                        {" "}
                        Fintech Companies{" "}
                      </NavDropdown.Item>
                    </div>
                    <div className="dropdown_column">
                      <h4>By company location</h4>
                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?location=delhi"
                      >
                        {" "}
                        Delhi{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?location=Noida"
                      >
                        {" "}
                        Noida{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?location=bangalore"
                      >
                        {" "}
                        Bangalore{" "}
                      </NavDropdown.Item>

                      <NavDropdown.Item
                        as={Link}
                        to="/user/find-job?location=hyderabad"
                      >
                        {" "}
                        Hyderabad{" "}
                      </NavDropdown.Item>
                    </div>
                  </div>
                </NavDropdown>

                {authenticate ? (
                  <NavDropdown
                    title={<span className="nav-dropdown-title">My Jobs</span>}
                    id="employer-dropdown"
                    className="items-hovers My_jobs_hover"
                    renderMenuOnMount={true}
                  >
                    <NavDropdown.Item as={Link} to="applied-job">
                      {" "}
                      Applied Jobs{" "}
                    </NavDropdown.Item>

                    <NavDropdown.Item as={Link} to="suggested-jobs">
                      {" "}
                      Suggested Jobs{" "}
                    </NavDropdown.Item>

                    <NavDropdown.Item as={Link} to="savedJobs">
                      {" "}
                      Saved Jobs{" "}
                    </NavDropdown.Item>

                    <NavDropdown.Item as={Link} to="notIntested-jobs">
                      {" "}
                      Archived Jobs{" "}
                    </NavDropdown.Item>
                  </NavDropdown>
                ) : (
                  <Link to="/about-us" className="nav-link">
                    <div
                      className="nav-link font-nav"
                      style={{
                        color: "black",
                        fontSize: "16px",
                      }}
                    >
                      About us
                    </div>
                  </Link>
                )}
              </div>

              {showSearchContainer && (
                <div className="new_search_container">
                  <input
                    className="new_input_search"
                    placeholder="Search..."
                    onChange={handleFilterJobsByTitle}
                    value={jobTitle}
                  />
                  <button className="new_search_button">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                    </svg>
                  </button>
                </div>
              )}
              {authenticate && (
                <div className="d-flex justify-content-center align-items-center gap-1">
                  <Dropdown show={showBadge} onToggle={handleBadgeToggle}>
                    <div
                      onClick={handleBadgeToggle}
                      id="dropdown-basic"
                      className={`${
                        !userProfileComaplete && "disabled-navItems"
                      } login-btn user-avatar`}
                    >
                      <IoNotifications fontSize={24} />
                      {allNotication?.unreadNotificaitonCount > 0 && (
                        <span className="badge-icon">
                          {allNotication?.unreadNotificaitonCount}
                        </span>
                      )}
                    </div>
                    <Dropdown.Menu className="notificaton_menu px-3 py-3">
                      <div>
                        <h4 className="notification-title d-flex justify-content-between">
                          <span>Notification</span>
                          <span
                            onClick={() =>
                              markAllAsReadUser(setNotificationLoader)
                            }
                            className="markAsRead d-flex gap-1"
                          >
                            {notificationLoader && (
                              <Oval width={15} height={15} />
                            )}{" "}
                            Read All
                          </span>
                        </h4>
                        <div className={`notification-list-wrapper`}>
                          {allNotication?.notifications?.results?.length > 0 ? (
                            allNotication?.notifications?.results?.map(
                              (notification, index) => (
                                <div
                                  key={index}
                                  className={`notification-items-list mb-2 ${
                                    notification?.status === "unread" &&
                                    "unread_bg"
                                  } `}
                                >
                                  <p className="d-flex justify-content-between">
                                    <span>
                                      {notification.notificationTitle}
                                    </span>
                                    {notification?.status === "unread" && (
                                      <button
                                        onClick={() =>
                                          handleMarkAsRead(notification?._id)
                                        }
                                        className="markAsRead"
                                      >
                                        Mark Read
                                      </button>
                                    )}
                                  </p>
                                  <p>{notification.notificationBody}</p>
                                  <p>
                                    {handleFormateDate(notification?.createdAt)}
                                  </p>
                                </div>
                              )
                            )
                          ) : (
                            <p className="text-center">No Data</p>
                          )}
                        </div>
                        <span
                          onClick={handleNotification}
                          className="notification-title text-underline"
                        >
                          View All
                        </span>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>

                  <Dropdown
                    className={`proofileDrop-menu`}
                    show={showDropdown}
                    onToggle={handleToggle}
                  >
                    <div
                      id="dropdown-basic"
                      className="login-btn ksjdhisdn"
                      onClick={handleToggle}
                    >
                      {profileImageUrl ? (
                        <img
                          className="profile-iconNav"
                          src={profileImageUrl}
                          alt="profile Image"
                        />
                      ) : (
                        <FaUserAlt fontSize={24} />
                      )}
                    </div>
                    <Dropdown.Menu className="profile-menu-items">
                      <div className="user_profile_iconsBox d-flex flex-column">
                        <Dropdown.Item
                          onClick={() => navigate("user-profile")}
                          className={`${
                            !userProfileComaplete && "disable-items"
                          } prifle_user_items`}
                        >
                          <div>
                            <img src={profileLight} alt="profileLight" />
                          </div>
                          <span>Profile</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => navigate("/user/notIntested-jobs")}
                          className={`${
                            !userProfileComaplete && "disable-items"
                          } prifle_user_items`}
                        >
                          <div>
                            <img
                              src={light_archive_outline}
                              alt="light_archive_outline"
                            />
                          </div>
                          <span>Archived Jobs</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => navigate("setting")}
                          className={`${
                            !userProfileComaplete && "disable-items"
                          } prifle_user_items`}
                        >
                          <div>
                            <CiSettings fontSize={28} color="#3284FF" />
                          </div>
                          <span>Setting</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => navigate("help-Support")}
                          className={`${
                            !userProfileComaplete && "disable-items"
                          } prifle_user_items`}
                        >
                          <div>
                            <img src={formkit_help} alt="formkit_help" />
                          </div>
                          <span>Help Centre</span>
                        </Dropdown.Item>
                        <div className="line_dividor" />
                        <Dropdown.Item
                          className="logout_nav_item"
                          onClick={handleLogOut}
                        >
                          <div>
                            <IoLogOutOutline color="#F06548" fontSize={24} />
                          </div>
                          <span> Log Out</span>
                        </Dropdown.Item>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}
            </Nav>
          </Navbar.Collapse>
          {authenticate ? (
            <div className="smallDevice_icons">
              <div className="top-nav-bar">
                <Dropdown show={showBadge} onToggle={handleBadgeToggle}>
                  <div
                    onClick={handleBadgeToggle}
                    id="dropdown-basic"
                    className={`${
                      !userProfileComaplete && "disabled-navItems"
                    } login-btn user-avatar`}
                  >
                    <IoNotifications fontSize={24} />
                    {allNotication?.unreadNotificaitonCount > 0 && (
                      <span className="badge-icon">
                        {allNotication?.unreadNotificaitonCount}
                      </span>
                    )}
                  </div>
                  <Dropdown.Menu className="notificaton_menu px-3 py-3">
                    <div>
                      <h4 className="notification-title d-flex justify-content-between">
                        <span>Notification</span>
                        <span
                          onClick={() =>
                            markAllAsReadUser(setNotificationLoader)
                          }
                          className="markAsRead d-flex gap-1"
                        >
                          {notificationLoader && (
                            <Oval width={15} height={15} />
                          )}{" "}
                          Read All
                        </span>
                      </h4>
                      <div className={`notification-list-wrapper`}>
                        {allNotication?.notifications?.results?.length > 0 ? (
                          allNotication?.notifications?.results?.map(
                            (notification, index) => (
                              <div
                                key={index}
                                className={`notification-items-list mb-2 ${
                                  notification?.status === "unread" &&
                                  "unread_bg"
                                } `}
                              >
                                <p className="d-flex justify-content-between">
                                  <span>{notification.notificationTitle}</span>
                                  {notification?.status === "unread" && (
                                    <button
                                      onClick={() =>
                                        handleMarkAsRead(notification?._id)
                                      }
                                      className="markAsRead"
                                    >
                                      Mark Read
                                    </button>
                                  )}
                                </p>
                                <p>{notification.notificationBody}</p>
                                <p>
                                  {handleFormateDate(notification?.createdAt)}
                                </p>
                              </div>
                            )
                          )
                        ) : (
                          <p className="text-center">No Data</p>
                        )}
                      </div>
                      <span
                        onClick={handleNotification}
                        className="notification-title text-underline"
                      >
                        View All
                      </span>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
                <Dropdown
                  className={`proofileDrop-menu`}
                  show={showDropdown}
                  onToggle={handleToggle}
                >
                  <div
                    id="dropdown-basic"
                    className="login-btn ksjdhisdn"
                    onClick={handleToggle}
                  >
                    {profileImageUrl ? (
                      <img
                        className="profile-iconNav"
                        src={profileImageUrl}
                        alt="profile Image"
                      />
                    ) : (
                      <FaUserAlt fontSize={24} />
                    )}
                  </div>
                  <Dropdown.Menu className="profile-menu-items">
                    <div className="user_profile_iconsBox d-flex flex-column">
                      <Dropdown.Item
                        onClick={() => navigate("user-profile")}
                        className={`${
                          !userProfileComaplete && "disable-items"
                        } prifle_user_items`}
                      >
                        <div>
                          <img src={profileLight} alt="profileLight" />
                        </div>
                        <span>Profile</span>
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => navigate("/user/notIntested-jobs")}
                        className={`${
                          !userProfileComaplete && "disable-items"
                        } prifle_user_items`}
                      >
                        <div>
                          <img
                            src={light_archive_outline}
                            alt="light_archive_outline"
                          />
                        </div>
                        <span>Archived Jobs</span>
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => navigate("setting")}
                        className={`${
                          !userProfileComaplete && "disable-items"
                        } prifle_user_items`}
                      >
                        <div>
                          <CiSettings fontSize={28} color="#3284FF" />
                        </div>
                        <span>Setting</span>
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => navigate("help-Support")}
                        className={`${
                          !userProfileComaplete && "disable-items"
                        } prifle_user_items`}
                      >
                        <div>
                          <img src={formkit_help} alt="formkit_help" />
                        </div>
                        <span>Help Centre</span>
                      </Dropdown.Item>
                      <div className="line_dividor" />
                      <Dropdown.Item
                        className="logout_nav_item"
                        onClick={handleLogOut}
                      >
                        <div>
                          <IoLogOutOutline color="#F06548" fontSize={24} />
                        </div>
                        <span> Log Out</span>
                      </Dropdown.Item>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          ) : (
            <div className="auth-buttons-container">
              <Link to="/user/login" className="auth-login-btn">
                Login
              </Link>
              <Link to="/user/register" className="auth-register-btn">
                Register
              </Link>

              <NavDropdown
                title={<span className="nav-dropdown-title">Employer</span>}
                id="employer-dropdown"
                className="items-hovers d-none d-sm-block"
                renderMenuOnMount={true}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/post-job"
                  className="dropdown-item-hover"
                >
                  Start Hiring
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/price-detail"
                  // onClick={handleNavItemClick("/employer/price-detail")}
                  className="dropdown-item-hover"
                >
                  Price Detail
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/policy"
                  // onClick={handleNavItemClick("/employer/policy")}
                  className="dropdown-item-hover"
                >
                  Refund Policy
                </NavDropdown.Item>

                <NavDropdown.Item
                  as={Link}
                  to="/company/login"
                  className="dropdown-item-hover"
                >
                  Employer Login
                </NavDropdown.Item>
              </NavDropdown>
            </div>
          )}
        </Navbar>
      </div>
    </>
  );
}
